import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);
const load = (k, d) => { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch { return d; } };

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [items, setItems] = useState(() => load("mb_cart", []));
  const [open, setOpen] = useState(false);
  const [postal, setPostal] = useState(() => load("mb_postal", ""));
  const [tier, setTier] = useState("standard");
  const [promo, setPromo] = useState("");
  const [localFavs, setLocalFavs] = useState(() => load("mb_favs", []));
  const [userFavs, setUserFavs] = useState([]);

  useEffect(() => localStorage.setItem("mb_cart", JSON.stringify(items)), [items]);
  useEffect(() => localStorage.setItem("mb_postal", JSON.stringify(postal)), [postal]);
  useEffect(() => localStorage.setItem("mb_favs", JSON.stringify(localFavs)), [localFavs]);
  useEffect(() => { setUserFavs(user?.favorites || []); }, [user]);

  const add = (p, qty = 1, option = null, silent = false) => {
    setItems((prev) => {
      const i = prev.findIndex((x) => x.product_id === p.id && x.option === option);
      if (i >= 0) { const n = [...prev]; n[i] = { ...n[i], qty: n[i].qty + qty }; return n; }
      return [...prev, { product_id: p.id, slug: p.slug, name: p.name, image: p.images?.[0], unit: p.unit, price: p.price, qty, option }];
    });
    if (!silent) { setOpen(true); toast.success("Ajouté au panier", { description: `${qty} × ${p.name}` }); }
  };
  const update = (i, qty) => setItems((prev) => prev.map((x, j) => (j === i ? { ...x, qty: Math.max(1, qty) } : x)));
  const remove = (i) => setItems((prev) => prev.filter((_, j) => j !== i));
  const clear = () => { setItems([]); setPromo(""); };

  const favorites = user ? userFavs : localFavs;
  const toggleFav = async (pid) => {
    if (user) { const { data } = await api.post(`/me/favorites/${pid}`); setUserFavs(data.favorites); }
    else setLocalFavs((f) => (f.includes(pid) ? f.filter((x) => x !== pid) : [...f, pid]));
  };

  const count = items.reduce((s, x) => s + x.qty, 0);
  const payload = { items: items.map(({ product_id, qty, option }) => ({ product_id, qty, option })), postal_code: postal || null, tier, promo_code: promo || null };

  return (
    <CartCtx.Provider value={{ items, add, update, remove, clear, open, setOpen, count, postal, setPostal, tier, setTier, promo, setPromo, favorites, toggleFav, payload }}>
      {children}
    </CartCtx.Provider>
  );
}
